<script setup lang="ts">
import { ClockIcon, UserIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '@/composable/useI18n'
import type { IMaintenanceComment } from '@/interfaces/entities/maintenance_comment'
import { formatDateWithTime } from '@/utils/date/date-time'

defineProps<{
  comments: IMaintenanceComment[]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="border border-stroke bg-white shadow-sm">
    <div class="border-b border-stroke bg-gray-2 px-4 py-3">
      <h2 class="text-base font-semibold text-black">{{ t('maintenance_detail.comments.title') }}</h2>
    </div>

    <div v-if="!comments.length" class="p-4 text-sm text-body">
      {{ t('maintenance_detail.comments.empty') }}
    </div>

    <div v-else class="space-y-3 p-4">
      <div
        v-for="comment in comments"
        :key="comment.id"
        class="border border-stroke bg-gray-2 p-4">
        <p class="whitespace-pre-wrap text-sm text-black">{{ comment.comment }}</p>
        <div class="mt-2 flex flex-wrap items-center gap-3 text-xs text-body">
          <span class="inline-flex items-center gap-1">
            <UserIcon class="h-3.5 w-3.5" aria-hidden="true" />
            {{ comment.user?.name || t('maintenance_detail.comments.unknown_user') }}
          </span>
          <span v-if="comment.created_at" class="inline-flex items-center gap-1">
            <ClockIcon class="h-3.5 w-3.5" aria-hidden="true" />
            {{ formatDateWithTime(comment.created_at) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
